// Static route table for the area; pages load lazily (one chunk + its CSS).
import type { RouteObject } from 'react-router-dom'
import { lazyPages } from '../../app/lazyRoute'
import type { CrumbHandle } from '../../shell'

const page = lazyPages('src/features/releases/pages.tsx', () => import('./pages'))
const crumb = (text: string): CrumbHandle => ({ crumb: () => text })

export const releasesRoutes: RouteObject[] = [
  {
    path: 'releases',
    handle: crumb('Releases'),
    children: [
      { index: true, lazy: page('ReleaseListPage') },
      { path: 'create', handle: crumb('Create'), lazy: page('ReleaseCreatePage') },
      {
        path: ':id',
        handle: { crumb: (match) => match.params.id ?? null } satisfies CrumbHandle,
        children: [
          { index: true, lazy: page('ReleaseEditPage') },
          { path: 'show', handle: crumb('Show'), lazy: page('ReleaseShowPage') }
        ]
      }
    ]
  }
]
